import { AiOutlineWarning } from "react-icons/ai";

export default function CustomWarningModal({ open, setOpen, onContinue }) {
	return (
		open && (
			<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
				<div className="bg-white rounded-2xl shadow-lg max-w-md w-full p-6">
					<div className="flex items-center gap-3">
						<AiOutlineWarning className="h-6 w-6 text-red-500" size={24} />
						<h2 className="text-lg font-semibold text-gray-800">Warning</h2>
					</div>
					<p className="mt-4 text-sm text-gray-600">
						Please enter at least one pricing detail.
					</p>
					<div className="mt-6 flex justify-end gap-3">
						<button
							className="px-4 py-2 text-sm rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100"
							onClick={() => setOpen(false)}
						>
							Cancel
						</button>
						<button
							className="px-4 py-2 text-sm rounded-lg bg-red-500 text-white hover:bg-red-600"
							onClick={() => {
								setOpen(false);
								onContinue(true);
								// Handle "Continue" action here
							}}
						>
							Continue
						</button>
					</div>
				</div>
			</div>
		)
	);
}
